/**
 * Component sizes to generate atomic classes.
 *
 * WARNING!!! `key` and `value` are required.
 * Other are used in iCMS
 */
const componentSize = [
    // default from atomic
    // ...atomic.component,
    // custom local
    { key: 'default', value: '3rem', title: `Default` }, // 48px
    { key: 'size-1', value: '2.5rem', title: 'Size 1'} //40px

];
exports.componentSize = componentSize;
